import React from "react";
import { Route, Redirect } from "react-router-dom";

import ErrorBoundary from "components/ErrorBoundary";

import { AuthContext } from "context/Auth";

export default function AuthRoute({
  layout: Layout,
  component: Component,
  auth,
  title,
  ...rest
}) {
  const { isAuthenticated } = React.useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated)
          return (
            <ErrorBoundary>
              <Layout>
                <Component {...props} />
              </Layout>
            </ErrorBoundary>
          );
        else return <Redirect to="/app" />;
      }}
    />
  );
}
